import React from 'react'
import styles from './personCard.module.css'
import { Link } from 'react-router-dom'

interface PersonShort {
	id: bigint
	first_name: string
	last_name: string
	nick_name: string
	photo: string
	number: number
	club_name: string
	club_logo: string
	role: string
	type: string
	gender: string
}
interface PersonCardProps {
	person: PersonShort
}

const PersonCard: React.FC<PersonCardProps> = ({ person }) => {
	return (
		<li className={styles.card}>
			{person.photo && (
				<Link to={`/persons/${person.id}`}>
					<div className={styles.photo_container}>
						<img
							className={styles.photo}
							src={person.photo}
							alt={`${person.first_name} ${person.last_name}`}
						/>
					</div>
				</Link>
			)}
			<div className={styles.details}>
				<h3>
					<Link to={`/persons/${person.id}`}>
						{person.nick_name ? (
							<span>{person.nick_name}</span>
						) : (
							<>
								<span>{person.first_name}</span>{' '}
								<span>{person.last_name}</span>
							</>
						)}
					</Link>
				</h3>

				<p className={styles.team_number}>{person.number}</p>
			</div>
			<div>
				<div className={styles.teams}>
					<div className={styles.team}>
						{person.club_logo && <img src={person.club_logo} alt={person.club_name} />}
						<span> {person.club_name} </span>
					</div>
				</div>
			</div>
		</li>
	)
}

export default PersonCard
